import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const Vessel = AiseaApiFactory.get("vessel");
import VoyageService from "@/services/voyageService";

export default {
  /**
   * 船舶検索
   *
   * @param context
   * @param data
   * @returns {*}
   */
  search: (context, data) => {
    return Vessel.search(data).then((response) => {
      context.commit("CREATE", response.data);
    });
  },
  /**
   * 対象船舶の最終地点を取得
   * @param context
   * @param vesselId
   * @returns {*}
   */
  getLastPosition: (_, vesselId) => {
    return VoyageService.getLastPosition(vesselId).then((response) => {
      return response.data;
    });
  },
  /**
   * 船舶データ全削除
   *
   * @param context
   */
  clear: (context) => {
    context.commit("CLEAR");
  },
};
